import {
  DISABLE_AUTO_BOUNDS_SEARCHING,
  ENABLE_AUTO_BOUNDS_SEARCHING,
  SET_BOUNDS,
  SET_USER_BOUNDS
} from 'bundles/research/index/store/actions/coordinates';

export default function(state = {
  autoBoundsSearchingEnabled: true
}, action) {
  switch (action.type) {
  case ENABLE_AUTO_BOUNDS_SEARCHING:
    return {
      ...state,
      autoBoundsSearchingEnabled: true
    };

  case DISABLE_AUTO_BOUNDS_SEARCHING:
    return {
      ...state,
      autoBoundsSearchingEnabled: false
    };

  case SET_BOUNDS:
    return {
      ...state,
      mapBounds: {
        northEast: action.northEast,
        southWest: action.southWest
      }
    };

  case SET_USER_BOUNDS:
    return {
      ...state,
      userBounds: action.bounds
    };

  default:
    return state;
  }
}
